//=============================================================================
//                       <--- Developed By Icon Team --->
//=============================================================================

// npm packages
import React, { useState, useEffect } from "react";
import { useLocation, useHistory } from "react-router-dom";
import i18n from "i18n";
import { useTranslation } from 'react-i18next';

// custom pages
import Logo from "assets/img/consent-logo.png";
import { consentStyles } from "../styles";
import auth from "apis/auth/auth";
import Loader from "components/Loader/CenteredLoader";
import TextField from "@material-ui/core/TextField";
import { withStyles } from "@material-ui/core/styles";

// material-ui
import Button from "@material-ui/core/Button";
import Card from "@material-ui/core/Card";
import Grid from "@material-ui/core/Grid";
import MenuItem from "@material-ui/core/MenuItem";
import KeyboardArrowDown from '@material-ui/icons/KeyboardArrowDown';
import InfoOutlinedIcon from '@material-ui/icons/InfoOutlined';
import Newsignaturelogo from 'assets/img/Henry Schein Thrive Signature.png';
import upgardeloyalty from 'apis/UpgradeLoyalty/upgardeloyalty';


// material-ui icons



// custom TextField
const CssTextField = withStyles({
    root: {
        "& div.Mui-focused": {
            color: "##D3D3D3",
        },
        "& .MuiFormdiv-root": {
            color: "#707070",
        },
        "& .MuiInputBase-input": {
            color: "#707070",
        },
        "& .MuiInput-underline:before": {
            borderBottomColor: "#707070!important",
        },
        "& .MuiInput-underline:after": {
            borderBottomColor: "#707070!important",
        },
        "& .MuiOutlinedInput-root": {
            "& fieldset": {
                borderColor: "#707070",
            },
            "&:hover fieldset": {
                borderColor: "#707070",
            },
            "&.Mui-focused fieldset": {
                borderColor: "#707070",
            },
            "&.MuiOutlinedInput-root": {
                borderRadius: '5px !important',
            },
            marginTop: 0,
        },
    },
})(TextField);


export default function FormOne({ setNext, setStates, states }) {

    const { getAdminConsentStatus, verifyAdminConsent } = auth();
    const classes = consentStyles();
    const location = useLocation();
    const history = useHistory();
    const { t } = useTranslation();
    const param = new URLSearchParams(location.search);
    const token = param.get("token");

    const [loading, setLoading] = useState(false);
    const [status, setStatus] = useState("");
    const [message, setMessage] = useState("");
    const [data, setData] = useState({ db: 'US' });
    const [loginToken, setLoginToken] = useState("");
    const { getShiptoDetail } = upgardeloyalty();



    // const handleSearch = async () => {
    //     try {
    //       const values = {
    //         shipto: states?.henryscheinaccount,
    //         country: "US",
    //       };
      
    //       const res = await getShiptoDetail(values);
      
    //       if (res.result_status == 1) {
    //         const flag = res?.data?.signature_flag; // ✅ use this directly
    //         setStatus(flag);
    //         const statusname = res?.data?.signature_status;
    //         setMessage(statusname)

      
    //         // ✅ check using flag instead of status
    //         if (flag === false || flag === null) {
    //           setNext("2");
    //         }
    //       }
    //       if (res.result_status == 0) {
           
           

      
    //         // ✅ check using flag instead of status
    //         if (res.message === "Account number not found. Please verify and try again") {
    //           setNext("2");
    //         }
    //       }
    //     } catch (err) {
    //       console.error("Error in handleSearch:", err);
    //     }
    //   };



    const handlesubmit = async () => {
        try {
            let error = false
            if (states?.practicefirstname == '') {
                setStates({
                    practicefirstnameerror: true
                })
                error = true

            }
            if (states?.practicelastname == '') {
                setStates({
                    practicelastnameerror: true
                })
                error = true

            }
            if (states?.henryscheinaccount == '') {
                setStates({
                    henryscheinaccountError: true
                })
                error = true
            }
            if (states?.title == '') {
                setStates({
                    titleerror: true
                })
                error = true
            }
            if (error) {
                return false
            }

            else {
                setStates({
                    practicefirstnameerror: false,
                    practicelastnameerror: false,
                    henryscheinaccountError: false,
                    titleerror: false
                })
                 setNext('2');
            }
        }
        catch (e) {
            console.log({ e });
        }
    }

    return (
        <>
            <div style={{ width: '100%', margin: 'auto', marginRight: 'auto', background: '#fff', fontFamily: 'Inter, sans-serif' }}>
            <img style={{ width: '100%' }} src={Newsignaturelogo}></img>
                <div style={{
                    border: '1px solid transparent',
                    borderBottomColor: '#ededf1',
                    width: '50%',
                    margin: 'auto'
                }}>
                    <h3 style={{
                        fontSize: '1.125em',
                        color: '#2c3345',
                        fontWeight: 600,
                        textAlign: 'center',
                        marginTop: '100px',
                        fontFamily: 'Inter, sans-serif'
                    }}>Complete the Form Below to Enroll in Henry Schein Thrive Signature</h3>
                </div>
                <Grid container spacing={2} className={classes.formtxt1}>
                    <Grid item xs={12} lg={3} className={classes.formtxt}></Grid>
                    <Grid item xs={12} lg={3} className={states?.henryscheinaccountError ? classes.formError1 : classes.formtxt}>
                        <div style={{
                            color: '#060606',
                            fontFamily: 'Inter, sans-serif',
                            fontWeight: 500,
                            fontSize: '.95em',
                            marginBottom: 10
                        }}
                        >
                            Henry Schein Account Number:</div>
                        <CssTextField
                            type="text"
                            autoComplete="off"
                            variant="outlined"
                            onChange={(e) => {
                                const regex = /^[0-9\s\-]*$/
                                if (regex.test(e?.target?.value)) {
                                    setStates({
                                        henryscheinaccount: e?.target?.value,
                                        henryscheinaccountError: false
                                    })
                                }
                            }
                            }
                            error={states?.henryscheinaccountError}
                            value={states.henryscheinaccount}

                        />
                         {/* {states?.henryscheinaccountError || status === true ? (
                                <div className={classes.errorTxt}>
                                    
                                    <p>
                                        {status === true && message === "Inprogress"
                                            ? "Signature Enrollment for this ShipTo inprogress"
                                            : status === true
                                            ? "You are already enrolled in Thrive Signature."
                                            : "This field is required."}
                                    </p>
                                </div>
                            ) : null} */}
                             {states?.henryscheinaccountError && <div className={classes.errorTxt}><InfoOutlinedIcon
                            className={classes.emailInputIcon}
                        /><p>This field is required.</p></div>}
                    </Grid>
                    <Grid item xs={12} lg={3} className={states?.titleerror ? classes.formError1 : classes.formtxt}>
                        <div style={{
                            color: '#060606',
                            fontFamily: 'Inter, sans-serif',
                            fontWeight: 500,
                            fontSize: '.95em',
                            marginBottom: 10
                        }}   >Title</div>
                        <CssTextField
                            select
                            autoComplete="off"
                            variant="outlined"
                            label="Please Select"
                            value={states.title} // Ensure it's controlled
                            onChange={(e) => {
                                setStates({

                                    title: e.target.value,
                                    titleerror: false
                                });
                            }}
                        >
                            <MenuItem value="">Please Select</MenuItem>
                            <MenuItem value="Dentist">Dentist</MenuItem>
                            <MenuItem value="Office Manager">Office Manager</MenuItem>
                            <MenuItem value="Dental Hygienist">Dental Hygienist</MenuItem>
                            <MenuItem value="Dental Assistant">Dental Assistant</MenuItem>
                            <MenuItem value="Billing Coordinator">Billing Coordinator</MenuItem>
                            <MenuItem></MenuItem>
                        </CssTextField>
                        {states?.titleerror && <div className={classes.errorTxt}><InfoOutlinedIcon
                            className={classes.emailInputIcon}
                        /><p>This field is required.</p></div>}
                    </Grid>
                    <Grid item xs={12} lg={3} className={classes.formtxt}></Grid>
                    <Grid item xs={12} lg={3} className={classes.formtxt}></Grid>
                    <Grid item xs={12} lg={3} className={states?.practicefirstnameerror ? classes.formError1 : classes.formtxt} style={{ marginTop: 20 }}>
                        <div style={{
                            color: '#060606',
                            fontFamily: 'Inter, sans-serif',
                            fontWeight: 500,
                            fontSize: '.95em',
                            marginBottom: 10
                        }}>Practice Owner Name</div>
                        <CssTextField
                            type="text"
                            autoComplete="off"
                            variant="outlined"
                            onChange={(e) => {
                                const regex = /^[a-zA-Z]*$/;
                                if (regex.test(e?.target?.value)) {

                                    setStates({
                                        practicefirstname: e?.target?.value,
                                        practiceOwnerName: `${e?.target?.value} ${states?.practicelastname}`,
                                        practicefirstnameerror: false
                                    })
                                }
                            }}
                            error={states?.practicefirstnameerror}
                            value={states.practicefirstname}
                        />
                        <label style={{
                            color: '#57647E',
                            fontFamily: 'Inter, sans-serif',
                            fontWeight: 500,
                            fontSize: '.75em',
                            marginTop: 5
                        }}>First Name</label>
                        {states?.practicefirstnameerror && <div className={classes.errorTxt}><InfoOutlinedIcon
                            className={classes.emailInputIcon}
                        /><p>This field is required.</p></div>}
                    </Grid>
                    <Grid item xs={12} lg={3} className={states?.practicelastnameerror ? classes.formError1 : classes.formtxt} style={{ marginTop: 50 }}>
                        <CssTextField
                            type="text"
                            autoComplete="off"
                            variant="outlined"
                            onChange={(e) => {
                                const regex = /^[a-zA-Z]*$/;
                                if (regex.test(e?.target?.value)) {

                                    setStates({
                                        practicelastname: e?.target?.value,
                                        practiceOwnerName: `${states?.practicefirstname} ${e?.target?.value}`,
                                        practicelastnameerror: false
                                    })
                                }
                            }}
                            error={states?.practicelastnameerror}
                            value={states.practicelastname}
                        />
                        <label style={{
                            color: '#57647E',
                            fontFamily: 'Inter, sans-serif',
                            fontWeight: 500,
                            fontSize: '.75em',
                            marginTop: 5
                        }}>Last Name</label>
                        {states?.practicelastnameerror && <div className={classes.errorTxt}><InfoOutlinedIcon
                            className={classes.emailInputIcon}
                        /><p>This field is required.</p></div>}
                    </Grid>
                    <Grid item xs={12} lg={3} className={classes.formtxt}></Grid>                              </Grid>
                <div style={{
                    border: '1px solid transparent',
                    borderTopColor: '#ededf1',
                    width: '50%',
                    margin: 'auto',
                    marginTop: 20,
                    paddingTop: 25
                }}>
                    <button style={{
                        float: 'right',
                        border: '1px solid transparent',
                        minWidth: '128px',
                        height: '3em',
                        color: '#fff',
                        borderRadius: 4,
                        background: '#2e69ff',
                        cursor: 'pointer'

                    }} 
                    // onClick={async () => {
                    //             const result = await handlesubmit(); // waits for validation
                    //             if (result !== false) {
                    //               await handleSearch(); // calls API if valid
                    //             }
                    //           }}
                    onClick={handlesubmit}
                              >Next</button>

                </div>
            </div>
        </>
    );
}